import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import { makeStyles, Typography } from '@material-ui/core';
import React__default, { useState, useEffect, useCallback } from 'react';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';

var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      position: "relative",
      padding: "3px",
      maxWidth: "400px",
      display: "flex",
      flexDirection: "row",
      background: "#F6F5F4",
      borderRadius: "20px"
    },
    btn: {
      display: "flex",
      justifyContent: "center",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      width: "50%",
      cursor: "pointer"
    },
    btnActive: {
      backgroundColor: "#fff",
      border: "1px solid #5DB463",
      borderRadius: "20px"
    },
    btnInactive: {
      backgroundColor: "transparent",
      border: "none"
    },
    indicator: {
      position: "absolute",
      transition: "transform 300ms ease-in-out",
      zIndex: "9"
    }
  };
});
var ToggleButton = function ToggleButton(_ref) {
  var onChange = _ref.onChange,
    segments = _ref.segments,
    value = _ref.value,
    className = _ref.className;
  var classes = useStyles();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    button = _useState4[0],
    setButton = _useState4[1];
  useEffect(function () {
    if (segments && segments.length && button) {
      if (value !== undefined) {
        setSelected(value);
        var index = segments === null || segments === void 0 ? void 0 : segments.findIndex(function (seg) {
          return seg.value === value;
        });
        handleIndicatorPosition(index);
      } else {
        setSelected(segments[0].value);
      }
    }
  }, [segments.length, value, button]);
  var buttonRef = useCallback(function (el) {
    var indicator = document.getElementById("indicator");
    if (indicator) {
      indicator.style.zIndex = "9";
      indicator.style.width = (el === null || el === void 0 ? void 0 : el.clientWidth) + "px";
      indicator.style.height = (el === null || el === void 0 ? void 0 : el.clientHeight) + "px";
    }
    setButton(el);
  }, []);
  var handleSelectOption = function handleSelectOption(value, index) {
    handleIndicatorPosition(index);
    setSelected(value);
    if (onChange) {
      onChange(value);
    }
  };
  var handleIndicatorPosition = function handleIndicatorPosition(index) {
    var indicator = document.getElementById("indicator");
    if (indicator) {
      indicator.style.transform = "translate3d(" + (button.clientWidth * index - 3) + "px, 0, 0)";
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: className ? className : classes.wrapper
  }, segments && segments.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      ref: buttonRef,
      id: "toggle-button-".concat(index),
      onClick: function onClick() {
        handleSelectOption(option.value, index);
      },
      key: index,
      className: clsx(classes.btn),
      tabIndex: 0,
      onKeyDown: function onKeyDown(event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
          event.preventDefault();
          event.target.click();
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      style: {
        zIndex: "10"
      },
      color: selected === option.value ? "primary" : "textPrimary",
      variant: selected === option.value ? "subtitle1" : "body1"
    }, option.label));
  }), /*#__PURE__*/React__default.createElement("div", {
    id: "indicator",
    className: clsx(classes.indicator, classes.btn, classes.btnActive)
  }));
};
ToggleButton.propTypes = {
  onChange: PropTypes__default.func,
  value: PropTypes__default.any,
  className: PropTypes__default.any,
  segments: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.string,
    value: PropTypes__default.any
  }))
};

export { ToggleButton as default };
//# sourceMappingURL=ToggleButton.js.map
